export type Language = 'en' | 'zh-HK' | 'zh-CN' | 'ja' | 'ko' | 'es';

export interface UIContent {
    screens: {
        [key: string]: {
            label: string;
            sublabel: string;
        };
    };
    common: {
        enterStation: string;
        preparing: string;
        close: string;
        loading: string;
    };
}

export const uiTranslations: Record<Language, UIContent> = {
    'en': {
        screens: {
            services: { label: 'SERVICES', sublabel: 'What We Offer' },
            about: { label: 'ABOUT US', sublabel: 'Our Story & Mission' },
            cases: { label: 'CASE STUDY', sublabel: 'Featured Work' },
            tech: { label: 'TECHNOLOGY', sublabel: 'Our Stack' },
            team: { label: 'OUR TEAM', sublabel: 'The Crew' },
            contact: { label: 'CONTACT', sublabel: 'Get In Touch' },
            news: { label: 'NEWS', sublabel: 'Latest Updates' },
            careers: { label: 'CAREERS', sublabel: 'Join The Team' },
        },
        common: {
            enterStation: 'ENTER THE STATION',
            preparing: 'PREPARING YOUR EXPERIENCE',
            close: 'CLOSE',
            loading: 'LOADING'
        }
    },
    'zh-HK': {
        screens: {
            services: { label: '服務介紹', sublabel: '我們提供的服務' },
            about: { label: '關於我們', sublabel: '品牌故事與使命' },
            cases: { label: '案例研究', sublabel: '精選專案' },
            tech: { label: '核心技術', sublabel: '技術架構' },
            team: { label: '團隊介紹', sublabel: '核心成員' },
            contact: { label: '聯絡我們', sublabel: '保持聯繫' },
            news: { label: '最新消息', sublabel: '公司動態' },
            careers: { label: '招賢納士', sublabel: '加入我們' },
        },
        common: {
            enterStation: '進入太空站',
            preparing: '正在準備您的體驗',
            close: '關閉',
            loading: '載入中'
        }
    },
    'zh-CN': {
        screens: {
            services: { label: '服务介绍', sublabel: '我们提供的服务' },
            about: { label: '关于我们', sublabel: '品牌故事与使命' },
            cases: { label: '案例研究', sublabel: '精选专案' },
            tech: { label: '核心技术', sublabel: '技术架构' },
            team: { label: '团队介绍', sublabel: '核心成员' },
            contact: { label: '联系我们', sublabel: '保持联系' },
            news: { label: '最新消息', sublabel: '公司动态' },
            careers: { label: '招贤纳士', sublabel: '加入我们' },
        },
        common: {
            enterStation: '进入太空站',
            preparing: '正在准备您的体验',
            close: '关闭',
            loading: '载入中'
        }
    },
    'ja': {
        screens: {
            services: { label: 'サービス', sublabel: '提供サービス' },
            about: { label: '会社概要', sublabel: '私たちの使命' },
            cases: { label: '導入事例', sublabel: '主要プロジェクト' },
            tech: { label: 'テクノロジー', sublabel: '技術スタック' },
            team: { label: 'チーム', sublabel: 'メンバー紹介' },
            contact: { label: 'お問い合わせ', sublabel: 'ご連絡ください' },
            news: { label: 'ニュース', sublabel: '最新情報' },
            careers: { label: '採用情報', sublabel: '一緒に働こう' },
        },
        common: {
            enterStation: 'ステーションに入場',
            preparing: '体験を準備中',
            close: '閉じる',
            loading: '読み込み中'
        }
    },
    'ko': {
        screens: {
            services: { label: '서비스', sublabel: '제공 서비스' },
            about: { label: '회사 소개', sublabel: '브랜드 스토리' },
            cases: { label: '사례 연구', sublabel: '주요 프로젝트' },
            tech: { label: '기술', sublabel: '기술 스택' },
            team: { label: '팀 소개', sublabel: '핵심 멤버' },
            contact: { label: '문의하기', sublabel: '연락주세요' },
            news: { label: '뉴스', sublabel: '최신 소식' },
            careers: { label: '채용 정보', sublabel: '함께하세요' },
        },
        common: {
            enterStation: '스테이션 입장',
            preparing: '경험 준비 중',
            close: '닫기',
            loading: '로딩 중'
        }
    },
    'es': {
        screens: {
            services: { label: 'SERVICIOS', sublabel: 'Lo Que Ofrecemos' },
            about: { label: 'NOSOTROS', sublabel: 'Historia y Misión' },
            cases: { label: 'CASOS', sublabel: 'Proyectos Destacados' },
            tech: { label: 'TECNOLOGÍA', sublabel: 'Nuestra Pila' },
            team: { label: 'EQUIPO', sublabel: 'El Personal' },
            contact: { label: 'CONTACTO', sublabel: 'Contáctanos' },
            news: { label: 'NOTICIAS', sublabel: 'Últimas Actualizaciones' },
            careers: { label: 'CARRERAS', sublabel: 'Únete al Equipo' },
        },
        common: {
            enterStation: 'ENTRAR A LA ESTACIÓN',
            preparing: 'PREPARANDO SU EXPERIENCIA',
            close: 'CERRAR',
            loading: 'CARGANDO'
        }
    }
};
